
import {defineComponent} from "vue";
import ModalDialog from "../ob1/ModalDialog.vue";
import Price from "../ob1/Price.vue";

export default defineComponent({
    name: "OptionEditoPopin",
    components: {ModalDialog, Price},
    props: {
        popinId: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        visual: {
            type: Object,
            required: false,
            default: null
        },
        sections: {
            type: Array,
            required: true
        },
        mentions: {
            type: String,
            required: false,
            default: ""
        },
        price: {
            type: Number,
            required: true
        },
        alertMessage: {
            type: String,
            required: false,
            default: null
        },
    },
});
